import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=774036e3&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=774036e3&prod&lang=css&scoped=true"
import style1 from "./SearchPage.vue?vue&type=style&index=1&id=774036e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774036e3",
  null
  
)

export default component.exports